import { BoxProps, HStack, Text } from "@chakra-ui/react";
import Icon from "components/Icon/Icon";
import CircleLoader from "components/Loader/CircularLoader";
import { AnimatePresence, motion } from "framer-motion";
import { when } from "utils";

interface SwapInfoProps extends BoxProps {
  isLoading?: boolean;
}

export function SwapInfo(props: SwapInfoProps) {
  const { children, isLoading, ...xprops } = props;

  return (
    <HStack {...xprops}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={`swap-info-motion-${isLoading ? "loading" : "stale"}`}
          style={{ display: "inherit", marginTop: "-3px" }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
        >
          {when(!!isLoading, <CircleLoader boxSize="24px" />, <Icon type="swapSync" boxSize="24px" />)}
        </motion.div>
      </AnimatePresence>
      <Text fontSize="sm" textTransform="uppercase" fontWeight="500" color="primary.default">
        {children}
      </Text>
    </HStack>
  );
}
